import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MeetIntro } from '../../types';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import React, { Component } from 'react';
import classNames from 'classnames';

import './styles.scss';

interface EmailCardProps {
    meetIntro: MeetIntro;
    cardTextHeader?: string;
    cardTextMessage?: string;
    isError?: boolean;
}

class EmailCard extends Component<EmailCardProps> {
    render() {
        return (
            <div className={classNames('email-card-container', { 'error-container': this.props.isError })}>
                <div className="recruiter-card-content-container">
                    <div className="recruiter-info-container">
                        <img className="image" src={this.props.meetIntro.meetBackgroundUrl} alt="company-logo" />
                        <div>
                            <div className="recruiter-name">{this.props.meetIntro.emailSender.givenName}</div>
                            <div className="recruiter-description">{this.props.meetIntro.emailSender.title}</div>
                        </div>
                    </div>
                    {this.props.cardTextHeader ? (
                        <div className="request-header">{this.props.cardTextHeader}</div>
                    ) : null}
                    {this.props.cardTextMessage ? (
                        <div className={classNames('request-sub-header', { 'error-message': this.props.isError })}>
                            {this.props.cardTextMessage}
                        </div>
                    ) : null}
                </div>
                <div className="mail-recruiter-button-container">
                    <a href={`mailto:${this.props.meetIntro.emailSender.email}`} className="main-recruiter-button">
                        <FontAwesomeIcon icon={faEnvelope} className="mail-recruiter-icon" />
                        {this.props.meetIntro.emailSender.email}
                    </a>
                </div>
            </div>
        );
    }
}

export default EmailCard;
